import React, {forwardRef, useImperativeHandle, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Divider} from '@blueprintjs/core';

import {
  Description,
  Scheduler,
  SelectNotificationRecipients,
  SelectNotificationType,
} from '../components';
import {removeWorkflow, saveWorkflow, updateWorkflow} from '../../../../store/actions/workflowActions';
import {useCurrentUser} from '../../../../hooks/use-user-current-workspace';
import {IState} from '../../../../store/reducers';
import {TRIGGER_SOURCE} from '../constants';

interface ScheduleFormProps {
  source: TRIGGER_SOURCE;
  sourceId?: number;
  data: any | null;
  edit: boolean;
}

const ScheduleForm = forwardRef(({
  source,
  sourceId,
  data,
  edit,
}: ScheduleFormProps, ref: any) => {
  const users = useSelector((state: IState) => state.users.users);
  const currentUser = useCurrentUser();
  const dispatch = useDispatch();

  const scheduleRef = useRef<any>(null);
  const notificationRef = useRef<any>(null);
  const recipientsRef = useRef<any>(null);

  const saveSchedule = () => {
    const scheduleForm = scheduleRef.current;

    if (!scheduleForm.validate()) {
      return;
    }

    const profile = {
      notification: notificationRef.current.getValue(),
    };
    const recipients = recipientsRef?.current?.getValue() || null;

    let payload: any = {
      profile,
      recipients,
      rrule: scheduleForm.getValue(),
    };

    if (edit) {
      const {uid} = (data || {});

      dispatch(updateWorkflow(uid, payload));
    } else {
      const active = true;

      payload = {
        ...payload,
        active,
      };

      if (source === TRIGGER_SOURCE.REPORT) {
        payload.report_id = sourceId;
      }

      dispatch(saveWorkflow(payload));
    }
  };

  const deleteSchedule = () => {
    const {uid} = (data || {});

    uid && dispatch(removeWorkflow(uid));
  }

  useImperativeHandle(ref, () => ({
    onSave() {
      saveSchedule();
    },
    onDelete() {
      deleteSchedule();
    }
  }));

  return (
    <div className="trigger-dialog__form">
      <Description
        text="Use a schedule trigger to start the run of a workflow automatically at a specific time interval."
      />
      <Divider/>
      <Scheduler
        defaultValue={data?.rrule}
        editMode={edit}
        ref={scheduleRef}
      />
      <Divider/>
      <SelectNotificationType
        data={data?.profile_json?.notification}
        ref={notificationRef}
      />
      <SelectNotificationRecipients
        data={data}
        users={users}
        currentUser={currentUser}
        edit={edit}
        ref={recipientsRef}
      />
    </div>
  );
});

export default ScheduleForm;
